import type { ComponentProps, FC } from 'react';
import { useNavigate } from 'react-router';

import { ButtonRow } from '../../components/global/ButtonRow/ButtonRow';
import { FlowStepWithContainer } from '../../components/layout/FlowStepWithContainer';
import { AboutForm } from '../../forms/event/About/AboutForm.tsx';
import { getCurrentStepInfo, getNextStep } from './eventOnboardingFlow.ts';
import { useOnboardingIncompleteEvent } from './hooks/useOnboardingIncompleteEvent.ts';

export const EventAbout: FC = () => {
  const navigate = useNavigate();
  const currentStep = 'about';
  const { currentStep: stepNumber, totalSteps, label: heading } = getCurrentStepInfo(currentStep);

  const { query, mutation } = useOnboardingIncompleteEvent({
    onMutationSuccess: () => void navigate(`../${getNextStep(currentStep)}`),
  });

  const onSubmit: ComponentProps<typeof AboutForm>['onSubmit'] = ({
    name,
    eventDetails,
    tags,
    category,
    description,
  }) => {
    mutation.mutate({
      name,
      eventDetails,
      tags,
      category,
      description,
    });
  };

  if (!query.data) {
    return null;
  }

  return (
    <FlowStepWithContainer
      bodyContent={
        <AboutForm
          buttonSlot={
            <ButtonRow
              primaryButton={{
                type: 'submit',
                text: 'Next',
                isPending: mutation.isPending,
              }}
              secondaryButton={{
                text: 'Back',
                onClick: () => void navigate(-1),
              }}
            />
          }
          defaultValues={query.data}
          onSubmit={onSubmit}
        />
      }
      heading={heading}
      progress={{ currentStep: stepNumber, totalSteps }}
    />
  );
};
